<template lang="pug">
  b-modal#teamnation(
  ref="teamnation"
  :title="$t('ui.team_nation')"
  centered
  no-fade
  :busy="loading"
  @show="reset"
  @shown="shown")
    table.tablex
      tbody
        tr
          td.head.fixed-100px
            div {{ $t('language.native.simplified_chinese') }}
          td
            span {{ teamNationList.length > 0 ? this.teamNationList[0].name_cn : '' }}
        tr
          td.head.fixed-100px
            div {{ $t('language.native.traditional_chinese') }}
          td
            span {{ teamNationList.length > 0 ? this.teamNationList[0].name_tw : '' }}
        tr
          td.head.fixed-100px
            div {{ $t('language.native.indonesian') }}
          td
            span {{ teamNationList.length > 0 ? this.teamNationList[0].name_id : '' }}
        tr
          td.head.fixed-100px
            div {{ $t('language.native.vietnamese') }}
          td
            span {{ teamNationList.length > 0 ? this.teamNationList[0].name_vn : '' }}
        tr
          td.head.fixed-100px
            div {{ $t('language.native.thai') }}
          td
            span {{ teamNationList.length > 0 ? this.teamNationList[0].name_th : '' }}
        tr
          td.head.fixed-100px
            div {{ $t('language.native.japanese') }}
          td
            span {{ teamNationList.length > 0 ? this.teamNationList[0].name_jp : '' }}
        tr
          td.head.fixed-100px
            div {{ $t('language.native.korean') }}
          td
            span {{ teamNationList.length > 0 ? this.teamNationList[0].name_kr : '' }}
    div(slot="modal-footer")
      SubmitButton.float-right(icon="far fa-times-circle" :text="$t('ui.close')" @click="closeModal()" size="sm")
</template>
<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";

export default {
  components: {
    SubmitButton
  },
  props: {
    teamNationList:{
      type: Array,
      default: []
    }
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  methods: {
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      //this.$v.$reset();
    },
    closeModal: function() {
      this.$refs.teamnation.hide();
    },
  }
};
</script>
<style lang="scss" scoped>
.head {
  padding: 0;
    color: #5c6873;
    background-color: rgba(220, 230, 238, 0.5);
}
.fixed-100px {
  min-width: 100px !important;
  max-width: 100px !important;
  width: 100px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>